module.exports = __webpack_public_path__ + "img/icon_emty.418ef633.png";